import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const OchranaSukromia: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-amber-50 to-sky-50 flex flex-col">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl font-bold text-blue-800">← Späť</Link>
            <div className="text-gray-600">Ochrana súkromia</div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-sm shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Ochrana súkromia a spracovanie osobných údajov
          </h1>
          
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">1. Kto je spracovateľom osobných údajov</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Spracovateľom vašich osobných údajov je:
                </p>
                <div className="bg-gray-50 rounded-md p-4">
                  <p className="font-semibold">Wavelyne SINGLE MEMBER P.C.</p>
                  <p>Leof. Andrea Siggrou 196</p>
                  <p>Kallithea 176 71, Athens, Greece</p>
                  <p>VAT: EL802952696</p>
                  <p className="mt-2">Email: <a href="mailto:diana@wavelynecode.com" className="text-blue-600 hover:underline">diana@wavelynecode.com</a></p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">2. Ktoré osobné údaje spracúvame</h2>
              <div className="space-y-3">
                <p><strong>Pri nákupe ebooku:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Meno a priezvisko</li>
                  <li>E-mailová adresa</li>
                  <li>Fakturačné údaje (ak sú vyžadované)</li>
                  <li>IP adresa (pre technické účely)</li>
                </ul>
                <p><strong>Pri používaní webovej stránky:</strong></p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Technické údaje o zariadení</li>
                  <li>Údaje o používaní stránky (analytics)</li>
                  <li>Súbory cookies</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">3. Na aký účel spracúvame osobné údaje</h2>
              <div className="space-y-3">
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Dodanie ebooku:</strong> Na zabezpečenie doručenia zakúpeného produktu</li>
                  <li><strong>Fakturácia:</strong> Na vystavenie a doručenie daňového dokladu</li>
                  <li><strong>Komunikácia:</strong> Na odpovedanie na vaše dotazy a požiadavky</li>
                  <li><strong>Zlepšenie služieb:</strong> Na analýzu používania stránky a optimalizáciu</li>
                  <li><strong>Platobné transakcie:</strong> Na spracovanie platieb</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">4. Právny základ spracovania</h2>
              <div className="space-y-3">
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Zmluvné vzťahy:</strong> Spracovanie je nevyhnutné pre plnenie zmluvy (nákup ebooku)</li>
                  <li><strong>Plnenie právnych povinností:</strong> Na účely účtovníctva a daní</li>
                  <li><strong>Oprávnený záujem:</strong> Na zabezpečenie bezpečnosti a zlepšenie služieb</li>
                  <li><strong>Súhlas:</strong> V prípadoch, kde je vyžadovaný váš výslovný súhlas</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">5. Komu môžeme údaje poskytnúť</h2>
              <div className="space-y-3">
                <p>Vaše osobné údaje môžeme poskytnúť tretím stranám iba v nasledovných prípadoch:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Platobné brány:</strong> Na spracovanie platieb (Viva Wallet)</li>
                  <li><strong>E-mailové služby:</strong> Na doručenie ebooku a komunikáciu</li>
                  <li><strong>Účtovnícke systémy:</strong> Na správu fakturácie</li>
                  <li><strong>Štátne orgány:</strong> Na plnenie zákonných povinností</li>
                </ul>
                <p>Žiadne iné tretie strany nebudú mať prístup k vašim osobným údajom.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">6. Ako dlho uchovávame údaje</h2>
              <div className="space-y-3">
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Fakturačné údaje:</strong> 10 rokov (podľa zákona o účtovníctve)</li>
                  <li><strong>E-mailové adresy:</strong> 3 roky od posledného nákupu</li>
                  <li><strong>Technické údaje:</strong> 1 rok</li>
                  <li><strong>Cookies:</strong> Podľa ich typu (session cookies do zatvorenia prehliadača)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">7. Vaše práva</h2>
              <div className="space-y-3">
                <p>V súlade s GDPR máte nasledovné práva:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Právo na prístup:</strong> Môžete požiadať o kópiu svojich údajov</li>
                  <li><strong>Právo na opravu:</strong> Môžete požiadať o opravu nesprávnych údajov</li>
                  <li><strong>Právo na výmaz:</strong> Môžete požiadať o vymazanie údajov</li>
                  <li><strong>Právo na obmedzenie spracovania:</strong> Môžete obmedziť spracovanie údajov</li>
                  <li><strong>Právo na prenositeľnosť:</strong> Môžete požiadať o prenos údajov</li>
                  <li><strong>Právo vzniesť námietku:</strong> Môžete namietnuť proti spracovaniu</li>
                  <li><strong>Právo sťažovať sa:</strong> Môžete podať sťažnosť dozornému orgánu</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">8. Cookies</h2>
              <div className="space-y-3">
                <p>Naša stránka používa nasledovné typy cookies:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Nevyhnutné cookies:</strong> Pre základnú funkčnosť stránky</li>
                  <li><strong>Analytické cookies:</strong> Na sledovanie návštevnosti a zlepšenie služieb</li>
                  <li><strong>Bezpečnostné cookies:</strong> Na ochranu pred útokmi</li>
                </ul>
                <p>Cookies môžete kedykoľvek spravovať v nastaveniach svojho prehliadača.</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">9. Bezpečnosť údajov</h2>
              <p className="leading-relaxed">
                Aplikujeme technické a organizačné opatrenia na ochranu vašich osobných údajov pred neoprávneným prístupom, 
                stratou, zničením alebo zmenou. Všetky údaje sú prenášané cez zabezpečené SSL spojenia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">10. Zmeny v ochrane súkromia</h2>
              <p className="leading-relaxed">
                Tento dokument môžeme čas od času aktualizovať. O všetkých zmenách vás budeme informovať 
                zverejnením novej verzie na tejto stránke.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-800 mb-4">11. Kontakt</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Ak máte akékoľvek otázky týkajúce sa ochrany súkromia alebo chcete uplatniť svoje práva, kontaktujte nás:
                </p>
                <div className="bg-gray-50 rounded-md p-4">
                  <p className="font-semibold">Wavelyne SINGLE MEMBER P.C.</p>
                  <p>Email: <a href="mailto:diana@wavelynecode.com" className="text-blue-600 hover:underline">diana@wavelynecode.com</a></p>
                </div>
              </div>
            </section>

            <div className="mt-12 p-6 bg-gradient-to-r from-blue-50 to-amber-50 rounded-xl border border-blue-200">
              <p className="text-sm text-gray-600 text-center">
                Tento dokument je platný od dňa 1.1.2024 a bol vypracovaný v súlade s NARIADENÍM EURÓPSKEHO PARLAMENTU A RADY (EÚ) 2016/679 (GDPR).
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OchranaSukromia;
